import React, { useState, useEffect, useCallback } from 'react';
import { TextField } from '@mui/material';

/**
 * DeferredTextField - a TextField that buffers input locally and only
 * propagates changes to the parent on onBlur. This prevents the parent
 * component from re-rendering on every keystroke.
 */
function DeferredTextField({ value, onChange, name, ...rest }) {
    const [localValue, setLocalValue] = useState(value ?? '');

    // Sync local value when the parent value changes (e.g. form reset)
    useEffect(() => {
        setLocalValue(value ?? '');
    }, [value]);

    const handleChange = useCallback((e) => {
        setLocalValue(e.target.value);
    }, []);

    const handleBlur = useCallback((e) => {
        // Only propagate if value actually changed
        if (e.target.value !== value) {
            if (onChange) {
                // Reuse the same synthetic-like event structure expected by localOnChange
                onChange({ target: { name, value: e.target.value } });
            }
        }
        if (rest.onBlur) {
            rest.onBlur(e);
        }
    }, [value, onChange, name, rest.onBlur]);

    return (
        <TextField
            {...rest}
            name={name}
            value={localValue}
            onChange={handleChange}
            onBlur={handleBlur}
        />
    );
}

export default DeferredTextField;
